import React from 'react';

import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

import {
  ContributorCompany,
  ContributorInformationContainer,
  ContributorName,
} from './Contributor/styled';

export const ResourceContributorsSubmitterContainer = styled.div`
  max-width: 700px;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;

  padding: 16px 0px;
  border-top: 1px solid rgba(23, 28, 51, 0.1);
  border-bottom: 1px solid rgba(23, 28, 51, 0.1);
`;

export const ResourceContributorsSubmitterText = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;
  color: rgba(23, 28, 51, 0.5);

  display: inline;
`;

interface ResourceContributorsSubmitterIconContainerProps {
  background: string;
}

export const ResourceContributorsSubmitterIconContainer = styled.div<ResourceContributorsSubmitterIconContainerProps>`
  width: 24px;
  height: 24px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  margin-right: 8px;

  border-radius: 100%;
  background: ${({ background }) => background};
  transform: translateY(4px);
`;

export const ResourceContributorsSubmitterLinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ResourceContributorsSubmitterLink = styled.a`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  color: rgba(31, 32, 37, 0.5);
  text-decoration-line: underline;
`;

export const ResourceContributorsSubmitterLinkFavicon = styled.img`
  height: 16px;
  width: 16px;
`;

interface ResourceContributorsSubmitterWrapperProps {
  justifyContent?: React.CSSProperties['justifyContent'];
}

export const ResourceContributorsSubmitterWrapper = styled.div<ResourceContributorsSubmitterWrapperProps>`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};
  gap: 12px;

  ${BREAKPOINTS.tablet} {
    flex-direction: row;
    gap: 6px;
  }

  position: relative;
`;

export const ResourceContributorsModifier = styled.div`
  ${ContributorCompany} {
    display: none;
  }

  ${ContributorName} {
    font-weight: 400;
    font-size: 18px;
    line-height: normal;
    color: var(--color-text);
  }

  ${ContributorInformationContainer} {
    gap: 5px;
  }
`;
